import axios from "axios";

export const headers = (session) => {
    return {
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
    }
}


export const headersMultipart = (session) => {
    return {
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'Content-Type': 'multipart/form-data',
        'X-User-Admin-Log-Token': session.admin_auth_token,
    }
}

export const get = (endpoint, session, cancelToken, params = {})  =>{
    return axios.get(
        endpoint,
        {
            params,
            headers: headers(session),
            cancelToken,
        }
    ).then((axiosResponse) => {
        if (axiosResponse?.response?.data?.status === "error") {
            console.log(axiosResponse?.response);
        } else {
            return axiosResponse;
        }
    });
}

export const post = (endpoint, session, cancelToken, params = {}, multiPart=true) => {
    return axios.post(
        endpoint,
        params,
        {
            headers: multiPart ? headersMultipart(session) : headers(session),
            cancelToken,
        }
    );
}

export const put = (endpoint, session, cancelToken, params = {}) => {
    return axios.put(
        endpoint,
        params,
        {
            headers: headers(session),
            cancelToken,
        }
    );
}

export const delete_ = (endpoint, session, cancelToken, params = {}) => {
    return axios.delete(
        endpoint,
        {
            headers: headers(session),
            cancelToken,
            params,
        }
    );
}

export const apiDelete = (endpoint, session, cancelToken, params = {}) => {
    return axios.delete(
        endpoint,
        {
            params: params,
            headers: headers(session),
            cancelToken,
        }
    );
}
